export const CHECK_DEPOSIT_FAILED_ERROR_MESSAGE = 'Check deposit failed';
